import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { RootCauseDivergedBarGraphGroupResult } from 'libs/end-to-end/src/root-cause-analysis';
import { capitalize } from 'lodash';
import { KARLA_FONT_FAMILY } from 'libs/end-to-end/src/types/branding/fonts';

export const BarChartTooltip: React.FC<{
  pct: string;
}> = (props) => {
  const { pct } = props;
  return (
    <div className="p-4 font-sans text-left bg-white rounded-md filter shadow-8px bg-opacity-70 backdrop-blur-sm">
      <p className="font-sans text-xs font-bold ">{pct}%</p>
    </div>
  );
};

export const DisparityBarChart: React.FC<{
  result: RootCauseDivergedBarGraphGroupResult;
  yAxisText: string;
  demographicKey: string;
  controlVariable: string;
}> = ({ result, yAxisText, demographicKey }) => {
  const controlledDisparity = result.controlled_disparity * 100;
  const notControlledDisparity = result.not_controlled_disparity * 100;

  const withKey = `With ${result.control_variable}`;
  const withoutKey = `Without ${result.control_variable}`;

  const maxDisparity = Math.max(controlledDisparity, notControlledDisparity);
  const minDisparity = Math.min(controlledDisparity, notControlledDisparity);

  const magnitude =
    Math.max(Math.abs(maxDisparity), Math.abs(minDisparity)) * 1.1;

  const yAxisTextCapitalized = capitalize(yAxisText);

  return (
    <ResponsiveBar
      data={[
        {
          [withKey]: notControlledDisparity,
          [withoutKey]: controlledDisparity,
        },
      ]}
      groupMode="grouped"
      valueFormat={(percentage: number) => `${percentage}`}
      margin={{ top: 0, right: 50, bottom: 50, left: 100 }}
      minValue={-magnitude}
      maxValue={magnitude}
      borderRadius={3}
      colors={['#3460E2', '#CE106F']}
      colorBy="id"
      label=""
      padding={0.25}
      innerPadding={3}
      keys={[withKey, withoutKey]}
      indexBy={demographicKey}
      enableGridX={false}
      axisLeft={{
        legend: yAxisTextCapitalized,
        legendOffset: -60,
        legendPosition: 'middle',
        tickPadding: 10,
        tickSize: 0,
        format: (value) => `${value}%`,
      }}
      tooltip={(d) => {
        return <BarChartTooltip pct={d.value.toFixed(1)} />;
      }}
      // Hide the bottom axis.
      axisBottom={{
        tickPadding: 0,
        tickSize: 0,
        format: () => ``,
      }}
      theme={{
        text: {
          fontFamily: KARLA_FONT_FAMILY,
          fontSize: 16,
        },
        axis: {
          domain: {
            line: {
              stroke: '#B8BABC',
              strokeWidth: 2,
            },
          },
          ticks: {
            line: {
              strokeWidth: 0,
            },
          },
          legend: {
            text: {
              stroke: '#791fd1',
              fontSize: 16,
              strokeWidth: 0.2,
            },
          },
        },
      }}
    />
  );
};
